import { render, staticRenderFns } from "./form16.vue?vue&type=template&id=5252acad&scoped=true"
import script from "./form16.vue?vue&type=script&lang=js"
export * from "./form16.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5252acad",
  null
  
)

export default component.exports